var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", [_vm._v("函数示例")]),
      _vm._v(" "),
      _c("js-code-editor", {
        ref: "chEditor",
        attrs: {
          mode: "javascript",
          readonly: true,
          "display-height": "200px"
        },
        model: {
          value: _vm.value,
          callback: function($$v) {
            _vm.value = $$v
          },
          expression: "value"
        }
      }),
      _vm._v(" "),
      _c(
        "el-button",
        { attrs: { type: "text" }, on: { click: _vm.handleCopy } },
        [_vm._v("复制")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }